<template>
  <HistoryRow>
    <template v-slot:icon>
      <span
        class="h-8 w-8 rounded-full bg-warning-500 flex items-center justify-center ring-8 ring-white text-white"
      >
        <IconNotification class="w-5 h-5 text-white"></IconNotification>
      </span>
    </template>

    <div>
      <p class="text-sm text-gray-500">
        <a href="#" class="font-medium text-gray-900" v-if="history.user">
          {{ history.user.name }}
        </a>
        {{ $t(`post.page.history.status.${history.action}`) }}
        {{ $t('post.page.history.from') }}
        <span class="text-gray-500">{{ getOldStatusName }}</span>
        {{ $t('post.page.history.to') }}
        <span class="text-gray-500">{{ getNewStatusName }}</span>
      </p>
    </div>
    <div class="text-right text-sm whitespace-nowrap text-gray-500">
      {{ moment(history.created_at).format('D MMMM') }}
    </div>
  </HistoryRow>
</template>

<script>
import { mapState } from 'vuex'
import HistoryMixin from './HistoryMixin'

export default {
  name: 'StatusHistory',
  mixins: [HistoryMixin],

  computed: {
    ...mapState('post', {
      statuses: (state) => state.statuses,
    }),
    getNewStatusName() {
      return this.getStatusName(this.history.new_value.status)
    },
    getOldStatusName() {
      return this.getStatusName(this.history.old_value.status)
    },
  },
  methods: {
    getStatusName(statusId) {
      if (statusId === null || statusId === undefined) {
        return this.$t('post.page.history.status.none')
      }
      if (!this.statuses) return String(statusId)
      const status = this.statuses.find((s) => s.id == statusId)
      if (!status) return String(statusId)
      const translation = status.translations
    ? status.translations.find((t) => t.locale === this.$i18n.locale)
    : null
    return translation ? translation.name : status.name || String(statusId)
    },
  },
}
</script>

<style scoped></style>
